import React from 'react';
import { YStack, XStack, Button, Text } from 'tamagui';
import { tokens } from 'tamagui-config';

interface UnlockKeypadProps {
  onNumberClick: (number: string) => void;
  onDelete?: () => void;
}

export const UnlockKeypad: React.FC<UnlockKeypadProps> = ({ onNumberClick }) => {
  // Create rows of numbers for the keypad
  const numberRows = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [0]];

  return (
    <YStack width="100%" height="288px" alignItems="center" gap="16px">
      {numberRows.map((row, index) => (
        <XStack key={index} justifyContent="center" gap="16px">
          {row.map((number) => (
            <Button
              key={number}
              width={60}
              height={60}
              backgroundColor={tokens.color.gray4}
              borderRadius="50%"
              alignItems="center"
              onPress={() => onNumberClick(number.toString())}
              pressStyle={{ transform: [{ scale: 0.95 }] }}>
              <Text fontFamily="$body" fontSize="$9.5" color={tokens.color.textLight}>
                {number}
              </Text>
            </Button>
          ))}
        </XStack>
      ))}
    </YStack>
  );
};
